// albumTracksSlice.js
import { asyncThunkCreator, buildCreateSlice } from "@reduxjs/toolkit";
import axios from "axios";

const createslicethunk = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

const SingleAlbumSlice = createslicethunk({
  name: "ArtistAlbum",
  initialState: {
    Singlealbum: null,
    status: "idle",
    error: null,
  },
  reducers: (create) => ({
    fetchSingleAlbums: create.asyncThunk(
      async () => {
        const accessToken = localStorage.getItem("access_token");
        const ArtistId = localStorage.getItem("artistId");
        try {
          const response = await axios.get(
            `https://api.spotify.com/v1/artists/${ArtistId}/albums?include_groups=single&limit=50`,
            {
              headers: {
                Authorization: ` Bearer ${accessToken} `,
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          );
          return response.data.items;
        } catch (error) {
          return error.response.data;
        }
      },
      {
        pending: (state) => {
          state.status = "loading";
        },
        rejected: (state, action) => {
          state.error = action.error;
          state.status = "failed";
        },
        fulfilled: (state, action) => {
          state.status = "succeeded";
          state.Singlealbum = action.payload;
        },
      }
    ),
  }),
});

export default SingleAlbumSlice.reducer;
export const { fetchSingleAlbums } = SingleAlbumSlice.actions;

//
